var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm flex justify-between items-center"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label)+" ")]),_vm._v(" "),(_vm.sublabel)?_c('span',[_vm._v(_vm._s(_vm.sublabel))]):_vm._e(),_vm._v(" "),(_vm.tip)?_c('TooltipVue',{attrs:{"tip":_vm.tip}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }